import { memo, useState } from 'react'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { SummaryReceiptRow } from "../constants/Column"
import { OrderReceipt } from "./types"

const InputOtherReq = memo(({ props } : {
  props: EditorProps<OrderReceipt, SummaryReceiptRow>
}) => {
  const { onClose, onRowChange, row } = props
  const [ comment, setComment ] = useState<string>(row.otherIssueNote || '')
  const [ otherQty, setOtherQty ] = useState<number>(row.otherIssue || 0)
  
  return <Modal show={true} onHide={onClose}
    okTheme='info'
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { ...row }
      updatedRow.otherIssue = otherQty
      updatedRow.otherIssueNote = comment
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title='บันทึกการเบิก FG จากแผนกอื่นๆ'
    maxWidth='max-w-lg'
    okDisable={otherQty < 0 || comment === ''}
    >
    <div className="w-full space-y-3 ">
      <div className="space-y-1">
        <p className="font-bold ">จำนวรวม</p>
        <small className=' text-muted'>กรอกจำนวนรวมทุกแผนกที่มาขอ</small>
        <input 
          className='input-form-text'
          type="number"
          inputMode="numeric"
          placeholder='กรอกยอดเบิกรวม'
          autoFocus={true}
          enterKeyHint='done'
          value={otherQty}
          onChange={(e) => setOtherQty(Number(e.currentTarget.value))}
        />
      </div> 
      <div className="space-y-1">
        <p className="font-bold ">เหตุผล</p>
        <small className=' text-muted'>กรอกรายละเอียดว่าแผนกไหน เบิกไปเท่าไร เช่น RD 2 EA, PK 2 EA เป็นต้น</small>
        <textarea 
          className={`input-form-text`}
          placeholder="กรุณากรอกเหตุผลการไม่อนุมัติ" 
          value={comment} onChange={(e) => setComment(e.currentTarget.value)}
          >
        </textarea>
      </div>
    </div>
  </Modal>
})

export default InputOtherReq